import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const FAQSection = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
      question: "What\'s included in the Free tier?",
      answer: `The Free tier includes access to 3 SAP Best Practice scope items, up to 10 questionnaire responses per month, basic document generation, and community support. Perfect for evaluating BPMLflows and small proof-of-concept projects.`
    },
    {
      question: "Can I upgrade or downgrade my plan anytime?",
      answer: `Yes, you can change your subscription tier at any time. Upgrades take effect immediately, while downgrades take effect at the next billing cycle. All your data and configurations are preserved during plan changes.`
    },
    {
      question: "What SAP Best Practices are supported?",
      answer: `BPMLflows supports all major SAP Best Practices across Lines of Business including Order-to-Cash (OTC), Procure-to-Pay (P2P), Record-to-Report (RTR), Plan-to-Produce, and Extended Warehouse Management (EWM). New scope items are added regularly.`
    },
    {
      question: "How does the AI assistance work?",
      answer: `Our AI engine analyzes your organization context, project history, and SAP Best Practice requirements to generate contextual questions and recommendations. It helps accelerate requirement gathering while maintaining accuracy and completeness.`
    },
    {
      question: "What document formats are supported?",
      answer: `BPMLflows generates Business Process Design Documents (BPD²) and Functional Specification Documents (FSD²) in PDF format with embedded diagrams. Documents include version control, digital signatures, and audit trails.`
    },
    {
      question: "Is there an implementation service available?",
      answer: `Yes, Enterprise customers receive dedicated implementation support including setup assistance, training sessions, and best practice guidance. Contact our sales team to discuss your specific implementation needs.`
    },
    {
      question: "What integrations are available?",
      answer: `BPMLflows integrates with popular enterprise tools including DocuSign for digital signatures, draw.io for diagram editing, and supports webhook integrations for custom workflows. API access is available for Enterprise customers.`
    },
    {
      question: "How is data security handled?",
      answer: `All data is encrypted in transit and at rest using enterprise-grade encryption. We maintain SOC 2 Type II compliance, ISO 27001 certification, and offer data residency options for global organizations with specific compliance requirements.`
    }
  ];

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="mt-20">
      <div className="text-center mb-12">
        <h2 className="text-3xl font-bold text-foreground mb-4">
          Frequently Asked Questions
        </h2>
        <p className="text-muted-foreground max-w-2xl mx-auto">
          Get answers to common questions about BPMLflows pricing, features, and implementation.
        </p>
      </div>
      <div className="max-w-3xl mx-auto space-y-4">
        {faqs?.map((faq, index) => (
          <div 
            key={index}
            className="bg-card border border-border rounded-lg overflow-hidden"
          >
            <button
              onClick={() => toggleFAQ(index)}
              className="w-full px-6 py-4 text-left flex items-center justify-between hover:bg-muted/50 nav-transition"
            >
              <h3 className="font-semibold text-foreground pr-4">
                {faq?.question}
              </h3>
              <Icon 
                name="ChevronDown" 
                size={20} 
                className={`text-muted-foreground flex-shrink-0 nav-transition ${
                  openIndex === index ? 'rotate-180' : ''
                }`}
              />
            </button>
            
            {openIndex === index && (
              <div className="px-6 pb-4 border-t border-border">
                <p className="text-muted-foreground leading-relaxed pt-4">
                  {faq?.answer}
                </p>
              </div>
            )}
          </div>
        ))}
      </div>
      {/* Contact Support */}
      <div className="text-center mt-12 p-8 bg-muted/30 rounded-xl">
        <h3 className="text-xl font-semibold text-foreground mb-2">
          Still have questions?
        </h3>
        <p className="text-muted-foreground mb-4">
          Our team is here to help you choose the right plan for your organization.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <a 
            href="mailto:sales@bpmlflows.com"
            className="inline-flex items-center space-x-2 text-primary hover:text-primary/80 nav-transition"
          >
            <Icon name="Mail" size={16} />
            <span>sales@bpmlflows.com</span>
          </a>
          <a 
            href="tel:+1-555-0123"
            className="inline-flex items-center space-x-2 text-primary hover:text-primary/80 nav-transition"
          >
            <Icon name="Phone" size={16} />
            <span>+1 (555) 012-3456</span>
          </a>
        </div>
      </div>
    </div>
  );
};

export default FAQSection;